/*
 * Copyright 2023. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { TokenConversionData, MigrationConfirmationModal } from "../../../../../models/TokenModel";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-token-conversion-confirmation-model",
  templateUrl: "./token-conversion-confirmation-model.component.html",
  styles: [
    ".migration-modal-ul {height: 100px; overflow: auto} .migration-modal-list {padding-left: 40px; margin-top: 10px}"
  ]
})
export class TokenConversionConfirmationModelComponent implements OnInit, OnDestroy {
  faCheck = faCheck;

  @Input()
  modalData!: TokenConversionData | MigrationConfirmationModal | any;
  onClose!: Subject<boolean>;
  isMigrationModal = false;

  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.onClose = new Subject();
    this.isMigrationModal = "merchantMigrationSummaries" in this.modalData;
  }

  handleConfirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    this.onClose.unsubscribe();
  }
}
